import React from "react";
import { useParams } from "react-router-dom";
import { games } from "../data/games";
import GameCard from "../components/GameCard";

function CategoryPage() {
  // 1. On récupère "platform" car c'est le nom défini dans App.jsx
  const { platform } = useParams();

  // Filtrage amélioré pour accepter plusieurs plateformes
const categoryGames = (games || []).filter((game) => 
  game.category?.toLowerCase().includes(platform?.toLowerCase())
);
  return (
    <div className="category-page" style={{ paddingTop: "120px", color: "white", minHeight: "100vh", backgroundColor: "#0b0b13" }}>
      <div className="container" style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px" }}>
        
        <h1 style={{ marginBottom: "40px", textTransform: "uppercase", fontSize: "2.5rem" }}>
          Jeux <span style={{ color: "#ec008c" }}>{platform}</span>
        </h1>

        {categoryGames.length > 0 ? (
          <div className="standard-grid" style={{ 
            display: "grid", 
            gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", 
            gap: "30px" 
          }}>
            {categoryGames.map((game) => (
              <GameCard key={game.id} game={game} />
            ))}
          </div>
        ) : (
          <div style={{ textAlign: "center", padding: "100px 20px" }}>
            <h3 style={{ opacity: 0.6 }}>Aucun jeu trouvé pour la plateforme "{platform}".</h3>
          </div>
        )}
      </div>
    </div>
  );
}

export default CategoryPage;